import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import AppLogo from "@/assets/images/favicon.png";
import { Button } from "@/components/Button/Button";
import { ButtonSize } from "@/components/Button/types";

/** Signal-value interstitial shown after the tracker list was created. */
export const TrackInterstitial: FunctionComponent<{ onContinue: () => void }> = ({
	onContinue,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`onboarding.track.${key}`);

	return (
		<div className="w-full flex flex-col items-center justify-center">
			<div className="flex w-[480px] max-w-[100%] flex-col items-center rounded-[20px] bg-white px-8 py-10 text-center shadow-[0px_0px_80px_0px_rgba(171,178,217,0.35)]">
				<img alt="logo" className="mb-4 h-10 w-10" src={AppLogo} />
				<div className="mb-2 flex h-10 w-10 items-center justify-center rounded-full bg-status-success-light text-lg text-status-success">
					✓
				</div>
				<div className="mb-2 text-md font-bold">{ts("interTitle")}</div>
				<div className="mb-6 text-ssm text-text-meta">{ts("interSubtitle")}</div>

				<div className="mb-6 w-full text-left">
					{[1, 2, 3].map((index) => (
						<div key={index} className="mb-4 flex items-start gap-3">
							<span className="mt-0.5 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-blue-action/10 text-xs font-bold text-brand-light">
								{index}
							</span>
							<span>
								<span className="block text-ssm font-semibold">{ts(`interStep${index}Title`)}</span>
								<span className="block text-xs text-text-meta">{ts(`interStep${index}Text`)}</span>
							</span>
						</div>
					))}
				</div>

				<Button className="w-full" size={ButtonSize.ML} title={ts("letsGo")} onClick={onContinue} />
			</div>
		</div>
	);
};
